export default __webpack_public_path__ + "static/media/logout-img.bcbdbb5e.png";